import { GIFIMAGE_NUMBER_TYPE } from "../../../graphic/constants";

export class DefaultCanvasGifImagePicker {
    constructor() {
        this.type = "gif-image", this.numberType = GIFIMAGE_NUMBER_TYPE;
    }
    contains(gifImage, point, params) {
        const {pickContext: pickContext} = null != params ? params : {};
        return !!pickContext && !!gifImage.AABBBounds.containsPoint(point);
    }
}
//# sourceMappingURL=gif-image-picker.js.map
